import { IAppState } from '../../common/state';

export const selectFullUrl = (state: IAppState): string => state.results.fullUrl;
